export const BRAND_NAME = "SHREE SAINATH MOTOR DRIVING SCHOOL";

// export const URL = 'http://localhost/NextDrive/';
// export const API_URL = "http://localhost/NextDrive/rest/";
// export const IMAGE_PATH = "http://localhost/NextDrive/rest/uploads/";

export const URL = "https://shreesainathmds.in/";
export const API_URL = "https://shreesainathmds.in/rest/";
export const IMAGE_PATH = "https://shreesainathmds.in/rest/uploads/";


export const IMAGE = "https://shreesainathmds.in/assets/images/hero.png";

export const MAX_RESULTS = 10;

export const LOGOUT_TIME = 1000 * 60 * 24;

export const EXCLUDE_URL = ["partner/login"];

export const CAPTACHA_SITE_KEY = "6LfcQwIsAAAAALw3_6MCSlqBd8BQ6ZAAFjuM3TfC";

export const PRODUCT_STATUS = {
  1: {
    name: "active",
    colorClass: "text-success",
  },
  2: {
    name: "deactive",
    colorClass: "text-danger",
  },
};

export const ORDER_STATUS = {
  1: {
    name: "processing",
    colorClass: "text-info",
  },
  2: {
    name: "complete",
    colorClass: "text-success",
  },
  3: {
    name: "rejected",
    colorClass: "text-danger",
  },
};

export const CUSTOMER_STATUS = {
  1: {
    name: "active",
    colorClass: "text-success",
  },
  2: {
    name: "deactive",
    colorClass: "text-danger",
  },
};

export const PAYMENT_STATUS = {
  1: {
    name: "paid",
    colorClass: "text-success",
  },
  2: {
    name: "not_paid",
    colorClass: "text-danger",
  },
  3: {
    name: "partial_paid",
    colorClass: "text-info",
  },
};

export const GST_TYPES = {
  1: "Registered - Regular GST",
  2: "Registered - Camp Scheme",
  3: "Unregistered Business",
  4: "Consumer B2C",
  5: "Overseas (Outside India)",
  6: "Special Economic Zone",
  7: "Deemed Export",
};

export const PAYMENT_MODE = {
  1: "CASH",
  2: "UPI",
  3: "NET BANKING",
  4: "CREDIT CARD",
  5: "DEBIT CARD",
  6: "CHEQUE",
  7: "CREDIT NOTE",
  8: "OTHER",
};

export const PAYMENT_TYPES = {
  1: "PAYMENT RECEIVED",
  2: "PAYMENT MADE",
};

export const VENDOR_ITEMS = {
  1: "Adjustment on purchase",
  2: "Adjustment on sales",
  3: "Advertising & Marketing",
  4: "Automobile expense",
  5: "Bonus",
  6: "Credit card charges",
  7: "Gain or loss on fluctuation in foreign currency",
  8: "IT & Internet expense",
  9: "Meals & Entertainment",
  10: "Medical Expenses",
  11: "Office supplies",
  12: "Operational",
  13: "Payment gateway charge",
  14: "Payroll",
  15: "Petrol Expenses",
  16: "CNG Expenses",
  17: "Diesel Expenses",
  18: "Printing & Stationery",
  19: "Rent",
  20: "Repairs & Maintenance",
  21: "Shipping charge",
  22: "Team building",
  23: "Telephone expense",
  24: "Travel expense",
  25: "Utilities",
};

export const HOT_KEYS = [
  { key: "alt+d", route: "/root", label: "Dashboard" },
  { key: "alt+i", route: "/root/invoices", label: "Invoices Master" },
  { key: "i+n", route: "/root/invoices/new", label: "New Invoice" },
  { key: "alt+o", route: "/root/po", label: "Purchase Orders" },
  { key: "o+n", route: "/root/po/new", label: "New Purchase Order" },
  { key: "alt+c", route: "/root/customer", label: "Customers" },
  { key: "c+n", route: "/root/customer/add", label: "New Customer" },
  { key: "alt+v", route: "/root/vendor", label: "Expense Ledgers" },
  { key: "v+n", route: "/root/vendor/add", label: "New Expense Ledger" },
  { key: "alt+p", route: "/root/product", label: "Products" },
  { key: "shift+p", route: "/root/payment", label: "Payment" },
  {
    key: "p+c",
    route: "/root/payment/customerPayment",
    label: "New Customer Payment",
  },
  {
    key: "p+v",
    route: "/root/payment/vendorPayment",
    label: "New Expense Ledger Payment",
  },
  { key: "alt+e", route: "/root/expense", label: "Expenses" },
  { key: "e+n", route: "/root/expense/new", label: "New Expense" },
  { key: "alt+a", route: "/root/admission", label: "Admissions" },
  { key: "a+n", route: "/root/admission/add", label: "New Admission" },
  { key: "alt+t", route: "/root/admission/attendance", label: "Attendance" },
];

export const VIEW_PERMISSIONS = [
  { key: 'dashboard', label: 'dashboard', group: 'general' },
  { key: 'customer_list', label: 'customer_list', group: 'customer' },
  { key: 'admissions', label: 'admissions', group: 'admission' },
  { key: 'admission_add', label: 'add_admission', group: 'admission' },
  { key: 'attendance', label: 'attendance', group: 'attendance' },
  { key: 'customer_attendance_history', label: 'customer_attendance_history', group: 'attendance' },
  { key: 'products', label: 'products', group: 'product' },
  { key: 'category', label: 'category', group: 'product' },
  { key: 'invoices', label: 'invoices', group: 'billing' },
  { key: 'payment', label: 'payment', group: 'billing' },
  { key: 'vendor', label: 'vendor', group: 'billing' },
  { key: 'expense', label: 'expenses', group: 'billing' },
  { key: 'reports', label: 'reports', group: 'report' },
  { key: 'messaging', label: 'messaging', group: 'communication' },
  { key: 'settings', label: 'settings', group: 'settings' },
  { key: 'users', label: 'users', group: 'settings' },
  { key: 'email_settings', label: 'email_settings', group: 'settings' },
];

export const lableStyle = {
  position: "absolute",
  top: "-10px",
  left: "23px",
  backgroundColor: "white",
  paddingLeft: "3px",
  paddingRight: "3px",
  zIndex: 1,
};

export const MOBILE_NUMBER = "8975970596";

export const ADDRESS =
  "Shop No. 19, BLOCK-D PALLADIUM EXOTICA Madhav Nagar, Dhanori, Pune, Maharashtra 411015";

export const EMAIL_ID = "info@sainathdrivingschool.in";
